import React from 'react'
import {
  Form, Input, Select
} from 'antd'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next';

const Option = Select.Option

const UserForm=Form.create({
  name:'user_form',
  // onFieldsChange(props, changedFields) {
  //   let obj={};
  //   Object.values(changedFields).forEach(item=>{
  //     obj[item.name]=item.value
  //   })
  //   props.onChange(obj);
  // },
  // mapPropsToFields(props){
  //   return {
  //     userName: Form.createFormField({value:props.user.userName}),
  //     email: Form.createFormField({value:props.user.email}),
  //     phoneNumber: Form.createFormField({value:props.user.phoneNumber}),
  //     operator: Form.createFormField({value:props.user.operator}),
  //     roleId: Form.createFormField({value:props.user.roleId})
  //   }
  // }
})(
  class UserFormClass extends React.Component{
    render(){
      const { t,form,operatorCodeList,curRoleId,curOperator,title}=this.props  
      let {roles}=this.props   
      const {userName,email,phoneNumber,roleId}=this.props.user       
      //console.log(roles,'roles');
      let operator = this.props.user.operator;      
      if(curRoleId === 3){
        operator = curOperator
      }
      //判断运营商编码临时写死下拉菜单角色方案
      if(curRoleId === 3&&curOperator==='MYDG'){
        roles=[{id: 7, name: "Logistic", menuIds: [15, 14], subRoleIds: []},{id: 8, name: "Store Sales", menuIds: [6, 9, 14], subRoleIds: []},{id: 9, name: "Call Center", menuIds: [6, 9, 14], subRoleIds: []}]
      }else if((curRoleId === 3&&curOperator==='THAIS')||(curRoleId === 3&&curOperator==='THDTAC')||(curRoleId === 3&&curOperator==='THTRUE')){
        roles=[{id: 23, name: "General Operator", menuIds: [6, 8, 9, 14], subRoleIds: []},{id: 24, name: "Visitor", menuIds: [14], subRoleIds: []}]
      }
      const { getFieldDecorator } = form      
      const formItemLayout = {
        labelCol: {
          xs: { span: 6 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 18 },
          sm: { span: 18 },
        },
      }
      return (
        <Form layout="vertical" {...formItemLayout}>
          {title==='edit'?
          <Form.Item label={t('Username')}>
            {getFieldDecorator('userName',{
              rules:[{required:true,message:t("-Enter-")}],
              initialValue:userName
            })(<Input disabled></Input>)}
          </Form.Item>
          :
          <Form.Item label={t('Username')}>
            {getFieldDecorator('userName',{
              rules:[{required:true,message:t("-Enter-")}],
              initialValue:userName
            })(<Input></Input>)}
          </Form.Item>
          }          
          <Form.Item label={t('Email')}>
            {getFieldDecorator('email',{
              rules:[{required:true,message:t("-Enter-")}],
              initialValue:email
            })(
              <Input></Input>
            )}
          </Form.Item>
          <Form.Item label={t('Phone Number')}>
            {getFieldDecorator('phoneNumber',{
              rules:[{required:true,message:t("-Enter-")}],
              initialValue:phoneNumber
            })(
              <Input></Input>
            )}
          </Form.Item>
          <Form.Item label={t('Carrier Code')}>
            {getFieldDecorator('operator',{
              rules:[{required:true,message:t("-Enter-")}],
              initialValue:operator
            })(              
              <Select disabled={curRoleId===3?true:false}>
                {
                  operatorCodeList.map(code=>(<Option value={code} key={code}>{code}</Option>))
                }
              </Select>
            )}
          </Form.Item>
          <Form.Item label={t('Role')}>
            {getFieldDecorator('roleId',{
              rules:[{required:true,message:t("-Enter-")}],
              initialValue:roles.some(item=>item.id ===roleId)?roleId:""
            })(
              <Select>
              {
                roles.map(role=>(<Option value={role.id} key={role.id}>{role.name}</Option>))
              }
            </Select>

            )}
          </Form.Item>
        </Form>
      )
    }
  }
)

const mapStateToProps = (state)=>{
  return {
    roles:state.roles,
    curRoleId:state.roleId,
    curOperator:state.operator
  }
}

export default connect(mapStateToProps)(withTranslation()(UserForm))